import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderSlot as _renderSlot, Transition as _Transition, withCtx as _withCtx, createVNode as _createVNode, Teleport as _Teleport, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-dadc8e38"),n=n(),_popScopeId(),n)
const _hoisted_1 = ["aria-label", "data-testid"]
const _hoisted_2 = ["data-testid"]
const _hoisted_3 = { class: "flex items-start gap-1" }
const _hoisted_4 = ["data-testid"]
const _hoisted_5 = { class: "min-w-0 flex-1 pt-1.5 text-left" }
const _hoisted_6 = { class: "truncate text-base font-bold text-gray-900" }
const _hoisted_7 = ["data-testid"]
const _hoisted_8 = {
  key: 1,
  class: "mt-1.5 flex flex-wrap gap-1"
}
const _hoisted_9 = { class: "min-h-0 flex-1 overflow-y-auto overscroll-contain px-4 py-3" }
const _hoisted_10 = ["data-testid"]

import { ref, toRef } from 'vue'
import { useOverlayA11y } from '@/composables/useOverlayA11y'

/** Tela cheia do celular (spec §4.3): cabeçalho fixo (←, título, meta) e dock inferior fixo. */

export default /*#__PURE__*/_defineComponent({
  __name: 'FullScreenPanel',
  props: {
    modelValue: { type: Boolean },
    title: {},
    meta: { default: undefined },
    testId: { default: 'full-screen-panel' }
  },
  emits: ["update:modelValue"],
  setup(__props: any, { emit }) {

const props = __props;



const panel = ref<HTMLElement | null>(null)

// O Tailwind só vale dentro de #app (`important: '#app'`). Sem #app (jsdom), renderiza no lugar.
// O Vue 3.3 resolve o `to` mesmo com o Teleport desabilitado; `body` sempre existe e evita o aviso.
const hasAppTarget = typeof document !== 'undefined' && !!document.getElementById('app')

function close(): void {
  emit('update:modelValue', false)
}

const { onPanelKeydown } = useOverlayA11y({
  panel,
  isOpen: toRef(props, 'modelValue'),
  onEscape: close
})

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_Teleport, {
    to: _unref(hasAppTarget) ? '#app' : 'body',
    disabled: !_unref(hasAppTarget)
  }, [
    _createVNode(_Transition, { name: "full-screen-panel" }, {
      default: _withCtx(() => [
        (_ctx.modelValue)
          ? (_openBlock(), _createElementBlock("section", {
              key: 0,
              ref_key: "panel",
              ref: panel,
              class: "full-screen-panel fixed inset-0 z-50 flex flex-col bg-white outline-none",
              role: "dialog",
              "aria-modal": "true",
              "aria-label": _ctx.title,
              tabindex: "-1",
              "data-testid": _ctx.testId,
              onKeydown: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_unref(onPanelKeydown) && _unref(onPanelKeydown)(...args)))
            }, [
              _createElementVNode("header", {
                class: "shrink-0 border-b border-gray-200 bg-white px-2 pt-[calc(0.5rem+env(safe-area-inset-top,0px))] pb-2",
                "data-testid": `${_ctx.testId}-header`
              }, [
                _createElementVNode("div", _hoisted_3, [
                  _createElementVNode("button", {
                    type: "button",
                    class: "flex h-10 w-10 shrink-0 items-center justify-center rounded-full text-lg text-gray-700",
                    "aria-label": "Voltar",
                    "data-testid": `${_ctx.testId}-back`,
                    onClick: close
                  }, " ← ", 8, _hoisted_4),
                  _createElementVNode("div", _hoisted_5, [
                    _createElementVNode("h2", _hoisted_6, _toDisplayString(_ctx.title), 1),
                    (_ctx.meta)
                      ? (_openBlock(), _createElementBlock("p", {
                          key: 0,
                          class: "text-xs text-gray-500",
                          "data-testid": `${_ctx.testId}-meta`
                        }, _toDisplayString(_ctx.meta), 9, _hoisted_7))
                      : _createCommentVNode("", true),
                    (_ctx.$slots['header-extra'])
                      ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
                          _renderSlot(_ctx.$slots, "header-extra")
                        ]))
                      : _createCommentVNode("", true)
                  ])
                ])
              ], 8, _hoisted_2),
              _createElementVNode("div", _hoisted_9, [
                _renderSlot(_ctx.$slots, "default")
              ]),
              (_ctx.$slots.dock)
                ? (_openBlock(), _createElementBlock("footer", {
                    key: 0,
                    class: "shrink-0 border-t border-gray-200 bg-white px-4 pt-3 pb-[calc(0.75rem+env(safe-area-inset-bottom,0px))]",
                    "data-testid": `${_ctx.testId}-dock`
                  }, [
                    _renderSlot(_ctx.$slots, "dock")
                  ], 8, _hoisted_10))
                : _createCommentVNode("", true)
            ], 40, _hoisted_1))
          : _createCommentVNode("", true)
      ]),
      _: 3
    })
  ], 8, ["to", "disabled"]))
}
}

})